export default {"src":"/_next/static/media/map.ec0d5e43.svg","height":321,"width":1440,"blurWidth":0,"blurHeight":0};